import React, { useEffect } from 'react';
import { preloadAllBikeCategoryImages, setBackgroundFromCache } from '../utils/globalImageCache';
import CachedImage from './CachedImage';
import EditableField from '../editry/EditableField';

// Preload all bike images at once when the component first loads
if (typeof window !== 'undefined' && !window.ridleyBikesPreloaded) {
  window.ridleyBikesPreloaded = true;
  
  // Delay execution slightly to ensure DOM is ready
  setTimeout(() => {
    preloadAllBikeCategoryImages();
  }, 100);
  
  // Create a navigation listener to improve transitions when returning to page
  window.addEventListener('popstate', () => {
    setTimeout(() => {
      document.querySelectorAll('.option2').forEach(el => {
        const url = el.dataset.imageSrc;
        if (url && el.id) {
          setBackgroundFromCache(el.id, url);
        }
      });
    }, 10);
  });
}

// A component to render a bike category
const BikeCategory = ({ pick, index, hrefTo, ridleyImage }) => {
  // Helper function to safely extract string values from Builder.io content
  const safeString = (value, fallback = '') => {
    if (typeof value === 'string') return value;
    if (typeof value === 'object' && value !== null) {
      // Handle Builder.io rich text objects
      if (value.Default) return value.Default;
      if (value['@type'] === 'string' && value.value) return value.value;
      // Try to extract text content if it's a complex object
      if (value.text) return value.text;
      if (value.content) return value.content;
    }
    return fallback;
  };

  const imageUrl = pick.data?.obrazek || ridleyImage;
  const elementId = (pick.data?.cesta || 'default') + "2";
  
  // Use React's useEffect to optimize image loading when returning to the page
  useEffect(() => {
    // If we're returning to the page, immediately try to set the image
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('hasVisitedHome') === 'true') {
      setBackgroundFromCache(elementId, imageUrl).catch(console.error);
    }
    
    // Always record image URL in the element's dataset for cache management
    const el = document.getElementById(elementId);
    if (el) {
      el.dataset.imageSrc = imageUrl;
    }
  }, [elementId, imageUrl]);
    
  // Use our improved CachedImage component that uses the enhanced caching system
  return (
    <CachedImage
      src={imageUrl}
      elementId={elementId}
      className="option2"
      asBackground={true}
      onClick={()=> hrefTo("/kola/"+(pick.data?.cesta || 'default'))}
      style={{
        backgroundColor: '#000',
        overflow: 'hidden'
      }}
      transitionDuration={0.7}
    >
      <h2 className="menu-text shadow">
        <EditableField model="pick-4" item={pick} field="nazev">
          {safeString(pick.data?.nazev, 'Kategorie kol')}
        </EditableField>
      </h2>
      <p id="popis-gravel" className="podpopis-vyber shadow">
        <EditableField model="pick-4" item={pick} field="popis">
          {safeString(pick.data?.popis, '')}
        </EditableField>
      </p>
    </CachedImage>
  );
};

export default BikeCategory;
